/* import __COLOCATED_TEMPLATE__ from './seo.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteEditMenuSeo extends Component {}
